module.exports = __webpack_public_path__ + "assets/img/caseH.55caf653.png";